const BLOCKS_HEIGHT_BUSINESS = $('.header').height() + $('.iyarn-business_business-hero').height() + $('.leading-companies').height();

$(document).scroll(function () {
    let y = $(this).scrollTop();
    if (y > BLOCKS_HEIGHT_BUSINESS && !getCookie('bannerShowedBusiness')) {
        $('#exampleModal').modal('show');
        setCookie('bannerShowedBusiness', 1, 14);
    }
});
